import { useEffect } from 'react';

import { useLocation, useRoutes, Navigate, useParams, useNavigate } from 'react-router-dom';

// auth
import LocalStorage from 'local-storage';
import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';
// layouts
import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';
import MainLayout from '../layouts/main';
// config
import { PATH_AFTER_LOGIN } from '../config-global';
import AppCache from '../services/appcache';
//
import {
    Page404,
    PageOne,
    LoginPage,
    UserGroup,
    UserRole,
    NewUser,
    EditUser,
    NewEntity,
    EntityType,

    ClaimDocumentDetails,
    EditEntityPage,
    SchemeDef,
    SchemeExceptionDef,
    NewSchemeException,
    NewScheme,
    Masters,
    InnoviceMaster,
    SchemeExceptionMaster,
    SchemeApproval,
    PointExemption,
    SchemeClaimMaster,
    CloseSchemeMaster,
    SchemeApprovalStatus,
    SchemeContractApprovalMaster,
    CLaimCreationMaster,
    RetailerProductWiseClaimGenerationMaster,
    RetailerProductWiseClaimReGenerationMaster,
    CLaimReGeneratonMaster,
    MasterContextWrapper,
    MasterClaimSubmissionContextWrapper,
    MasterReportsContextWrapper,
    MasterSchemeDefReportContextWrapper,
    MasterClaimClosureHistoryContextWrapper,
    MasterClaimSummaryReportContextWrapper,

    ContractClaimApprovalContextWrapper,
    MasterContractClaimApproval,
    ContractConsolidatePage,
    ContractClaimApprovalForm,

    MasterContextWrapperLoylaty,
    MasterLoylatyPage,
    AddLoyaltyMaster,
    EditLoyaltyMaster,

    ClaimItem,
    ImportData,
    OutletWiseClaimSubmission,
    ClaimApprovalStatus,
    AdjustmentApproval,
    ApproverOnLeave,
    RegenerateClaimOfRejectedMails,
    ContractTemplate,
    ManualClaimGenerationMaster,
    ContractClaimPreview,
    CoordinatorResendMail,
    AddSchemeConversion,
    EditSchemeConversion,
    SchemeConversionMaster,
    RetailerWiseProductWiseSchemeMaster,
    EditRetailerWiseProductWiseScheme,
    RetailerProductWiseClaimApprovalMaster,
    DbCompareMaster
} from './elements';

import ApprovalHierarchyMaster from '../pages/ApprovalHierarchyDefinition/ApprovalHierarchy/ApprovalHierarchyMaster';
import DistributorClaimApproval from '../pages/DistributorClaimApproval/DistributorClaimApproval';
import LoyaltySetOpeningPoint from '../pages/Loyalty/LoyaltySetOpening/LoyaltySetOpeningPoint';
import ProfileDetails from '../layouts/main/ProfileDetails/ProfileDetail';
import PostedFilterMaster from '../pages/PostedFilter/PostedFilterMaster';
import { ErrorBoundary } from '../commons/ErrorBoundary';
import SchemeDefMaster from '../pages/SchemeMaster/SchemeDefMaster';
import SchemeDefMasterAdd from '../pages/SchemeMaster/SchemeDefMasterAdd';
import RetailerProductWiseSchemeReportMaster from '../pages/Reports/RetailerProductWiseSchemeReport/RetailerProductWiseSchemeReportMaster';
// ----------------------------------------------------------------------

export default function Router() {

    const location = useLocation();
    const navigate = useNavigate();



    const searchParams = new URLSearchParams(location.search);

    const token = searchParams.get('token');
    const form = searchParams.get('form');
    const tokenn = localStorage.getItem('_UserToken'); // Adjust the storage method as needed

    useEffect(() => {
        // Skip token check for specific routes
        const skipTokenCheckRoutes = [
            '/DistributorClaimApproval',
            '/login',
            '/ContractClaimApproval'
        ];

        const isSkipRoute = skipTokenCheckRoutes.some(route =>
            location.pathname.startsWith(route)
        );

        if (!tokenn && !isSkipRoute) {
            navigate('/login'); // Redirect to login if token is absent            
        }
    }, [navigate, tokenn, location.pathname]);
















    const CoordinatorResendMailRouter = () => <ErrorBoundary><CoordinatorResendMail /> </ErrorBoundary>
    const LoyaltySetOpeningPointRouter = () => <ErrorBoundary><LoyaltySetOpeningPoint /> </ErrorBoundary>
    const ContractTemplateRouter = () => <ErrorBoundary><ContractTemplate /> </ErrorBoundary>
    const CLaimCreationRouter = () => <ErrorBoundary><CLaimCreationMaster /> </ErrorBoundary>
    const RetailerProductWiseClaimGenerationMasterRouter = () => <ErrorBoundary><RetailerProductWiseClaimGenerationMaster /> </ErrorBoundary>
    const RetailerProductWiseClaimApprovalMasterRouter = () => <ErrorBoundary><RetailerProductWiseClaimApprovalMaster /> </ErrorBoundary>
    const RetailerProductWiseClaimReGenerationMasterRouter = () => <ErrorBoundary><RetailerProductWiseClaimReGenerationMaster /> </ErrorBoundary>
    const CLaimReGeneratonMasterRouter = () => <ErrorBoundary><CLaimReGeneratonMaster /> </ErrorBoundary>
    const RegenerateClaimOfRejectedMailsRouter = () => <ErrorBoundary><RegenerateClaimOfRejectedMails /> </ErrorBoundary>
    const ImportDataRouter = () => <ErrorBoundary><ImportData /> </ErrorBoundary>
    const SchemeContractApprovalMasterRouter = () => <ErrorBoundary><SchemeContractApprovalMaster /> </ErrorBoundary>
    const ClaimDocumentDetailsRouter = () => <ErrorBoundary><ClaimDocumentDetails /> </ErrorBoundary>
    const MasterLoylatyPageRouter = () => <ErrorBoundary><MasterLoylatyPage /> </ErrorBoundary>
    const SchemeApprovalStatusRouter = () => <ErrorBoundary><SchemeApprovalStatus /> </ErrorBoundary>
    const RetailerWiseProductWiseSchemeMasterRouter = () => <ErrorBoundary><RetailerWiseProductWiseSchemeMaster /> </ErrorBoundary>
    const RetailerProductWiseSchemeReportMasterRouter = () => <ErrorBoundary><RetailerProductWiseSchemeReportMaster /> </ErrorBoundary>



    const SchemeRouter = () => {
        const { masterName } = useParams();

        return (
            <>
                {
                    masterName === 'scheme-approval' && <ErrorBoundary> <SchemeApproval /></ErrorBoundary>
                }
                {
                    masterName === 'scheme-definition' && <ErrorBoundary><SchemeDef /></ErrorBoundary>
                }
                {
                    masterName === 'Scheme-Exception' && <ErrorBoundary><SchemeExceptionMaster /></ErrorBoundary>
                }
            </>
        )
    }

    const MastersRouter = () => <ErrorBoundary> <Masters /> </ErrorBoundary>
    const ContractClaimPreviewRouter = () => <ErrorBoundary><ContractClaimPreview /> </ErrorBoundary>
    const ApproverOnLeaveRouter = () => <ErrorBoundary><ApproverOnLeave /> </ErrorBoundary>
    const PostedFilterRouter = () => <ErrorBoundary><PostedFilterMaster /> </ErrorBoundary>
    const PointExemptionRouter = () => <ErrorBoundary><PointExemption /> </ErrorBoundary>
    const OutletWiseClaimSubmissionRouter = () => <ErrorBoundary><OutletWiseClaimSubmission /> </ErrorBoundary>
    const InnoviceMasterRouter = () => <ErrorBoundary><InnoviceMaster /> </ErrorBoundary>
    const AdjustmentApprovalRouter = () => <ErrorBoundary><AdjustmentApproval /> </ErrorBoundary>







    if ((location.pathname === '/DistributorClaimApproval/:email/:id' || location.pathname === '/login' || location.pathname === '/ContractClaimApproval/:email/:id') && token === null && form === null) {
        AppCache.RemoveItemFromLocalStorage();
    }






    if (token !== null && token !== '') {
        LocalStorage.clear();
        AppCache.SetCurrentLoggedInUser(token);
        AppCache.GetCurrentLoggedInUser();
        AppCache.SetIsRedirect('1');
        AppCache.GetIsRedirect();
        if (token !== null && form === 'entity') {
            window.location.href = '/main/postedfilter/filter';
        }

        if (token !== null && form === 'claimdocumentdetaisreport') {
            window.location.href = '/main/report/claimdocumentdetails';
        }
    }

    return useRoutes([
        {
            path: '/',
            children: [
                { element: <Navigate to='login' replace />, index: true },
                {
                    path: 'login',
                    element: (
                        <GuestGuard>
                            <LoginPage />
                        </GuestGuard>
                    ),
                },
            ],
        },
        {
            path: 'DistributorClaimApproval/:email/:id',
            element: (
                <GuestGuard>
                    <LoginPage />
                </GuestGuard>
            ),
        },
        {

            path: 'ContractClaimApproval/:email/:id',
            element: (
                <GuestGuard>
                    <LoginPage />
                </GuestGuard>
            ),

        },

        {
            path: '/DistributorClaimApproval',
            element: <ErrorBoundary>  <DistributorClaimApproval /> </ErrorBoundary>,
        },




        {
            path: '/masters',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'approver-on-leave/:pageType',
                    element: <ApproverOnLeaveRouter />
                },
                {
                    path: 'approver-on-leave',
                    element: <ApproverOnLeaveRouter />
                },
                {
                    path: ':masterName/',
                    element: <MastersRouter />
                },
                {
                    path: ':masterName/:pageType',
                    element: <MastersRouter />
                },
                {
                    path: 'import-data',
                    element: <ImportDataRouter />
                },
                {
                    path: 'db-compare',
                    element: <ErrorBoundary><DbCompareMaster /></ErrorBoundary>
                },
                {
                    path: 'db-compare/:pageType',
                    element: <ErrorBoundary><DbCompareMaster /></ErrorBoundary>
                },
            ]
        },

        {
            path: '/loyalty',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'LoyaltyOpeningSet',
                    element: <ErrorBoundary> <LoyaltySetOpeningPointRouter /></ErrorBoundary>
                },
                {
                    path: 'loyalty-master',
                    element: <ErrorBoundary><MasterContextWrapperLoylaty /></ErrorBoundary>,
                    children: [
                        {
                            path: ':menuAlias',
                            element: <MasterLoylatyPageRouter />,
                        },
                        {
                            path: ':menuAlias/add',
                            element: <AddLoyaltyMaster />
                        },
                        {
                            path: ':menuAlias/edit',
                            element: <EditLoyaltyMaster />
                        },
                    ]
                },
            ]

        },


        {
            path: 'claim-submission',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'claim-item',
                    element: <ErrorBoundary> <ClaimItem /> </ErrorBoundary>,
                    children: [
                        {
                            path: ':pageType',
                            element: <ClaimItem />
                        }
                    ]
                },
                {
                    path: 'claim-submission',
                    element: <ErrorBoundary><MasterClaimSubmissionContextWrapper /> </ErrorBoundary>,
                    children: [
                        {
                            path: ':pageType',
                            element: <MasterClaimSubmissionContextWrapper />
                        }
                    ]
                },
                {
                    path: 'template',
                    element: <OutletWiseClaimSubmissionRouter />,
                    children: [
                        {
                            path: ':pageType',
                            element: <OutletWiseClaimSubmissionRouter />,
                        }
                    ]
                }



            ]
        },
        {
            path: 'contract',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'contract-template',
                    element: <ContractTemplateRouter />,

                },
                {
                    path: 'adjustment-template',
                    element: <ContractTemplateRouter />,

                },

                {
                    path: 'Claim-Preview',
                    element: <ContractClaimPreviewRouter />,

                },
            ]
        },
        {
            path: '/reports',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: ':masterName/',
                    element: <ErrorBoundary> <SchemeApprovalStatusRouter /></ErrorBoundary>
                },
                {
                    path: 'claim-approval-status/',
                    element: <ErrorBoundary> <ClaimApprovalStatus /></ErrorBoundary>
                },
                {
                    path: 'claim-approval-status/:pageType',
                    element: <ErrorBoundary> <ClaimApprovalStatus /></ErrorBoundary>

                },
                {
                    path: 'scheme-approval-status',
                    element: <ErrorBoundary> <SchemeApprovalStatusRouter /></ErrorBoundary>

                },
                {
                    path: 'retailer-product-wise-scheme-report',
                    element: <ErrorBoundary> <RetailerProductWiseSchemeReportMasterRouter /></ErrorBoundary>

                },
                {
                    path: 'reports-master',
                    element: <ErrorBoundary><MasterReportsContextWrapper /></ErrorBoundary>,
                    children: [
                        {
                            path: ':menuAlias',
                            element: <MasterReportsContextWrapper />
                        }
                    ]
                },
                {
                    path: 'scheme-definition-report',
                    element: <ErrorBoundary> <MasterSchemeDefReportContextWrapper /></ErrorBoundary>,
                    children: [
                        {
                            path: ':pageType',
                            element: <MasterSchemeDefReportContextWrapper />
                        }
                    ]
                },
                {
                    path: ':masterName/:pageType',
                    element: <ErrorBoundary> <SchemeApprovalStatusRouter /></ErrorBoundary>
                },
                {
                    path: 'claim-closure-history',
                    element: <ErrorBoundary> <MasterClaimClosureHistoryContextWrapper /></ErrorBoundary>,
                    children: [
                        {
                            path: ':pageType',
                            element: <MasterClaimClosureHistoryContextWrapper />
                        }
                    ]
                },
                {
                    path: 'claim-summary-report',
                    element: <ErrorBoundary> <MasterClaimSummaryReportContextWrapper /></ErrorBoundary>,
                    children: [
                        {
                            path: ':pageType',
                            element: <MasterClaimSummaryReportContextWrapper />
                        }
                    ]
                }

            ]
        },
        {
            path: '/scheme',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: ':masterName/',
                    element: <SchemeRouter />
                },
                {
                    path: ':masterName/:pageType',
                    element: <SchemeRouter />
                },
                {
                    path: 'scheme-definition/:pageType/:id',
                    element: <ErrorBoundary> <SchemeDefMaster /> </ErrorBoundary>
                    // element: <ErrorBoundary> <EditSchemeDef /> </ErrorBoundary>
                },
                {
                    path: 'scheme-definition/add',
                    element: <ErrorBoundary> <SchemeDefMasterAdd /></ErrorBoundary>
                    // element: <ErrorBoundary> <NewScheme /></ErrorBoundary>
                },
                {
                    path: 'scheme-conversion',
                    element: <ErrorBoundary> <SchemeConversionMaster /></ErrorBoundary>
                },
                {
                    path: 'scheme-conversion/add',
                    element: <ErrorBoundary> <AddSchemeConversion /></ErrorBoundary>
                },
                {
                    path: 'scheme-conversion/edit',
                    element: <ErrorBoundary> <EditSchemeConversion /> </ErrorBoundary>

                },

                {
                    path: 'retailer-wise-product-wise-scheme',
                    element: <ErrorBoundary> <RetailerWiseProductWiseSchemeMasterRouter /></ErrorBoundary>
                },
                {
                    path: 'retailer-wise-product-wise-scheme/edit',
                    element: <ErrorBoundary> <EditRetailerWiseProductWiseScheme /></ErrorBoundary>
                }
            ]
        },
        {
            path: '/adjustment',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'adjustment-approval',
                    element: <ErrorBoundary><AdjustmentApprovalRouter /> </ErrorBoundary>
                },
                {
                    path: 'adjustment-approval/:pageType',
                    element: <ErrorBoundary> <AdjustmentApprovalRouter /> </ErrorBoundary>
                },
                {
                    path: ':masterName/',
                    element: <PointExemptionRouter />
                },
                {
                    path: ':masterName/:pageType',
                    element: <PointExemptionRouter />
                },

            ]
        },
        {
            path: '/approval',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: ':masterName/',
                    element: <ErrorBoundary> <ApprovalHierarchyMaster /></ErrorBoundary>
                },
                {
                    path: ':masterName/:pageType',
                    element: <ErrorBoundary><ApprovalHierarchyMaster /> </ErrorBoundary>
                },

            ]
        },
        {
            path: 'masters/lock-scheme',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: '',
                    element: <ErrorBoundary> <CloseSchemeMaster /></ErrorBoundary>
                },
            ]
        },
        {
            path: '/adjustments',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: ':masterName/',
                    element: <InnoviceMasterRouter />
                },
                {
                    path: ':masterName/:pageType',
                    element: <InnoviceMasterRouter />
                },

            ]
        },


        {
            path: '/claim',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: 'claim-aproval',
                    element: <ErrorBoundary> <SchemeClaimMaster /> </ErrorBoundary>,
                    children: [
                        {
                            path: ':pageType',
                            element: <SchemeClaimMaster />
                        },
                    ]
                },
                {
                    path: 'retailer-product-wise-claim-approval',
                    element: <ErrorBoundary> <RetailerProductWiseClaimApprovalMasterRouter /> </ErrorBoundary>,
                    children: [
                        {
                            path: ':pageType',
                            element: <RetailerProductWiseClaimApprovalMasterRouter />
                        },
                    ]
                },
                {
                    path: 'claim-creation',
                    element: <CLaimCreationRouter />,

                },
                {
                    path: 'retailer-product-wise-claim-generation',
                    element: <RetailerProductWiseClaimGenerationMasterRouter />,

                },





                {
                    path: 'claim-recreation',
                    element: <CLaimReGeneratonMasterRouter />,

                },
                {
                    path: 'retailer-product-wise-claim-regeneration',
                    element: <RetailerProductWiseClaimReGenerationMasterRouter />,

                },
                {
                    path: 'regenerate-rejected-claim',
                    element: <RegenerateClaimOfRejectedMailsRouter />,

                },
                {
                    path: 'manual-contract-claim-generation',
                    element: <ErrorBoundary> <ManualClaimGenerationMaster /> </ErrorBoundary>,

                },

                {
                    path: 'scheme-hierarchy-classification',
                    element: <ErrorBoundary> <MasterContextWrapper /> </ErrorBoundary>,
                    children: [
                        {
                            path: ':pageType',
                            element: <MasterContextWrapper />
                        }
                    ]
                },
                {
                    path: 'coordinator-resend-mail',
                    element: <CoordinatorResendMailRouter />,

                },
                {
                    path: 'ContractClaimApproval',
                    element: <ErrorBoundary> <ContractClaimApprovalContextWrapper /> </ErrorBoundary>,
                    key: 'ContractClaimApproval',
                    children: [
                        {
                            path: '',
                            element: <MasterContractClaimApproval key='ContractClaimApproval' contractMaster="ContractClaimApproval" />
                        },
                        {
                            path: 'ContractConsolidate/:Id',
                            element: <ContractConsolidatePage contractMaster="ContractClaimApproval" />
                        },
                        {
                            path: 'ContractClaimApprovalForm',
                            element: <ContractClaimApprovalForm contractMaster="ContractClaimApproval" />
                        },
                    ]
                },
                {
                    path: 'ContractClaimReview',
                    element: <ErrorBoundary> <ContractClaimApprovalContextWrapper /> </ErrorBoundary>,

                    children: [
                        {
                            path: '',
                            element: <MasterContractClaimApproval key='ContractClaimReview' contractMaster="ContractClaimReview" />
                        },
                        {
                            path: 'ContractConsolidate/:Id',
                            element: <ContractConsolidatePage contractMaster="ContractClaimReview" />
                        },
                        {
                            path: 'ContractClaimApprovalForm',
                            element: <ContractClaimApprovalForm contractMaster="ContractClaimReview" />
                        },
                    ]
                },
                {
                    path: 'AllContractClaimReview',
                    element: <ErrorBoundary> <ContractClaimApprovalContextWrapper /> </ErrorBoundary>,

                    children: [
                        {
                            path: '',
                            element: <MasterContractClaimApproval key='AllContractClaimReview' contractMaster="AllContractClaimReview" />
                        },
                        {
                            path: 'ContractConsolidate/:Id',
                            element: <ContractConsolidatePage contractMaster="AllContractClaimReview" />
                        },
                        {
                            path: 'ContractClaimApprovalForm',
                            element: <ContractClaimApprovalForm contractMaster="AllContractClaimReview" />
                        },
                    ]
                },


            ]
        },
        {
            path: '/approvalhierarchy',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                {
                    path: ':masterName/',
                    element: <SchemeContractApprovalMasterRouter />
                },
                {
                    path: ':masterName/:pageType',
                    element: <SchemeContractApprovalMasterRouter />
                },
                {
                    path: 'criteria-approval-hierarchy',
                    element: <ErrorBoundary> <MasterContextWrapper /></ErrorBoundary>,
                    children: [
                        {
                            path: ':pageType',
                            element: <MasterContextWrapper />
                        }
                    ]
                }
                /* {
                    path: 'scheme-hierarchy-classification',
                    element: <MasterContextWrapper />,
                    children: [
                        {
                            path: ':pageType',
                            element: <MasterContextWrapper />
                        }
                    ]
                } */

            ]
        },
        {
            path: '/dashboard',
            element: (
                <AuthGuard>
                    <DashboardLayout />
                </AuthGuard>
            ),
            children: [
                { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
                { path: 'one', element: <PageOne /> },

                {
                    path: 'user',
                    children: [
                        { element: <Navigate to="/dashboard/user/four" replace />, index: true },

                    ],
                },
            ],
        },

        {
            path: '/main',
            element: (
                <GuestGuard>
                    <MainLayout />
                </GuestGuard>
            ),
            children: [
                { element: <Navigate to={PATH_AFTER_LOGIN} replace />, index: true },
                /*  { path: 'one', element: <PageOne /> }, */


                // { element: <Navigate to="/main/one" replace />, index: true },
                // { path: 'one', element: <PageOne /> },
                { path: 'systemadminstration/user-group', element: <UserGroup /> },
                { path: 'systemadminstration/entitytype', element: <EntityType /> },
                { path: 'systemadminstration/newuser', element: <NewUser /> },
                { path: 'systemadminstration/edituser', element: <EditUser /> },
                { path: 'systemadminstration/newentity', element: <NewEntity /> },
                { path: 'systemadminstration/user-role', element: <UserRole /> },
                { path: 'getentities/editentitypage', element: <EditEntityPage /> },
                { path: 'posted-filter/filter', element: <PostedFilterRouter /> },
                { path: 'upload-document/filter', element: <PostedFilterRouter /> },
                { path: 'posted-filter', element: <PostedFilterRouter /> },
                { path: 'posted-filter/:pageType', element: <PostedFilterRouter /> },
                { path: 'upload-document', element: <PostedFilterRouter /> },
                { path: 'upload-document/:pageType', element: <PostedFilterRouter /> },
                { path: 'report/claimdocumentdetails', element: <ClaimDocumentDetailsRouter /> },
                { path: 'schemedefination/schemedef', element: <SchemeDef /> },
                { path: 'schemeexception/schemeexceptiondef', element: <SchemeExceptionDef /> },
                { path: 'schemeexception/newschemeexception', element: <NewSchemeException /> },
                {
                    path: 'user-profile',
                    element: <ProfileDetails />,

                },


            ],
        },
        {
            element: <CompactLayout />,
            children: [{ path: '404', element: <Page404 /> }],
        },
        { path: '*', element: <Navigate to="/404" replace /> },
    ]);
}